import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AtendimentoModule} from "./atendimento/atendimento.module";
import {ClienteModule} from "./cliente/cliente.module";

const routes: Routes = [
  {
    path: 'atendimento',
    loadChildren: () => AtendimentoModule
  },
  {
    path: 'cliente',
    loadChildren: () => ClienteModule
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CadastroRoutingModule { }
